import low from 'lowdb'

import LocalStorage from 'lowdb/adapters/LocalStorage'

const adapter = new LocalStorage(`wx-mobile`)
const db = low(adapter)

db.defaults({
    sys: {},
    database: {},
    userinfo: null,
}).write()

export default db
